import logoUrl from "/proximi-logo.png";

import { cn } from "@/lib/utils";

interface LogoProps {
  /** Diameter of the circular mark in px. */
  size?: number;
  /** Show the "Proximi.io" wordmark next to the mark. */
  withWordmark?: boolean;
  /** Optional subtitle under the wordmark (e.g. "Indoor Wayfinding"). */
  subtitle?: string;
  className?: string;
}

/**
 * Proximi.io brand row. The mark is the supplied teal pin logo
 * (design/proximi-logo.png, copied to /public). Brand teal #17AEBF is
 * sampled from it and lives as the `--primary` token. The ".io" is tinted
 * with the primary token so it tracks the active theme.
 */
export function Logo({ size = 28, withWordmark = true, subtitle, className }: LogoProps) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <img
        src={logoUrl}
        alt="Proximi.io"
        width={size}
        height={size}
        className="rounded-full object-contain"
        style={{ width: size, height: size }}
      />
      {withWordmark && (
        <div className="leading-tight">
          <span className="font-semibold text-fg" style={{ fontSize: 18 }}>
            Proximi<span className="text-primary">.io</span>
          </span>
          {subtitle && (
            <div className="text-[11px] text-faint" style={{ marginTop: -1 }}>
              {subtitle}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
